<div class="card">
  <div class="card-body">
    <div class="row">
      <div class="col-md-12 pt-0">
        <h5 class="border-bottom pb-1 mb-1">{{ 'broadcasting.Upload Consolidated Meeting Report' | translate }}</h5>
      </div>
      <div class="col-lg-12">
        <spinner [id]="'editexcel'" [show]='activeSpinner'></spinner>
      </div>
      <div class="col-12 mt-4">
        <div class="row">
          <div class="col-12 col-xl-3 col-md-6">
            <div class="form-group ">
              <label>{{'header.assesmentyear' | translate }}<span class="required-field">*</span></label>
              <select [(ngModel)]="editweightfilter['ay']" class="form-control custom-selectbox w-100">
                <option *ngFor="let year of yearDropDownList" value="{{year}}">{{year}}</option>
              </select>
            </div>
          </div>
          <div class="col-12 col-xl-3 col-md-6">
            <div class="form-group">
              <label>{{'dataSubs.month' | translate }}<span class="required-field">*</span></label>
              <select [(ngModel)]="editweightfilter['month']" class="form-control custom-selectbox"
                (change)="changeMonth()">
                <option value="" [disabled]="true">{{'monthmaps.selcecttag' | translate}}</option>
                <option *ngFor="let month of monthsList" [value]="month.key">
                  {{'monthmaps.' + month['value'] | translate}}</option>
              </select>
            </div>
          </div>
          <div class="col-12 col-xl-6 col-md-6">
            <div class="form-group">
              <label>{{'header.state' | translate}}<span class="required-field">*</span></label>
              <select disabled class="form-control custom-selectbox selectdis">
                <option *ngFor="let state of statelists" value="{{state['uuid']}}">{{'tabledataforstates.' +state['name'] | translate}}</option>
              </select>
            </div>
          </div>
          <div class="col-12 col-xl-6 col-md-6">
            <div class="form-group">
              <label>{{ 'broadcasting.Select File (in pdf format and max size 5 MB)' | translate }}<span class="required-field">*</span></label>
              <input type="file" [(ngModel)]="selectedFiles" (change)="filechoosen($event)" name="file"
                class="form-control pointer" style="padding: 0px; height:32px">
            </div>
          </div>
          <div class="d-flex align-items-end justify-content-start" *ngIf="selectedFiles">
            <div class="form-group">
              <button class="btn btn-danger mr-3" (click)="removechosenfile()">{{'submitdata.Remove' | translate}}</button>
            </div>
          </div>
          <div class="col-auto d-flex align-items-end justify-content-start">
            <div class="form-group">
              <button class="btn btn-info pointer" (click)="previewFileUpload()" type="submit">{{ 'broadcasting.Preview' | translate }}</button>
            </div>
          </div>
          <div class="col-auto d-flex align-items-end justify-content-start">
            <div class="form-group">
              <button class="btn btn-info pointer" (click)="openUploadWindow()" type="submit">{{ 'broadcasting.Upload' | translate }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

  <div class="card">
    <div class="card-body">
      <div class="row">
        <div class="col-12 d-flex justify-content-start mt-2">
          <div class="form-group">
            <label>{{'header.assesmentyear' | translate }}<span class="required-field">*</span></label>
            <select [(ngModel)]="editweightfilter['ay']" class="form-control custom-selectbox w-100">
              <option *ngFor="let year of yearDropDownList" value="{{year}}">{{year}}</option>
            </select>
          </div>&nbsp;&nbsp;
          <div class="form-group">
            <label class="w-100">&nbsp;&nbsp;<span class="required-field"></span></label>
            <button class="btn btn-info pointer" (click)="fetchtableData()"
              type="submit">{{'dataSubs.VIEW' | translate}}</button>
          </div>
        </div>
        <div class="table-responsive table-responsive-lg table-responsive-md table-responsive-sm" *ngIf="showtabledata">
          <cdk-virtual-scroll-viewport #scrollViewport itemSize="10"
            [style.height]="fetchReport && fetchReport.length > 0 ? '250px' : '180px'">
            <table class="table text-center table-sm mt-1">
              <thead class="thead-light">
                <tr style="position:sticky; top: -0.5px;">
                  <th>{{'submitdata.slno' | translate}}</th>
                  <th>{{'trigManage.statename' | translate}}</th>
                  <th>{{ 'dataSubs.Date of Submission' | translate }} </th>
                  <th>{{'trigManage.filedownload' | translate}}</th>
                </tr>
              </thead>
              <tbody class="text-white" *ngIf="fetchReport && fetchReport.length > 0">
                <tr *ngFor="let table of fetchReport ; let i = index">
                  <td style="text-align: center">{{i+1}}</td>
                  <td style="text-align: center">{{'tabledataforstates.'+ table['stateName'] | translate}}</td>
                  <td style="text-align: center">{{table['date']}}</td>
                  <td class="text-center"><a><i class="fa fa-download pointer" (click)="downloadConsolidatedReport(table['fileuuid'])"
                        aria-hidden="true"></i></a></td>
                </tr>
              </tbody>
            </table>
          </cdk-virtual-scroll-viewport>
          <div class="row" *ngIf="fetchReport && fetchReport.length == 0">
            <div class="col-12 nodata">
              {{'infotab.nodata' | translate}}
            </div>
          </div>
        </div>
        
      </div>
    </div>
  </div>
  


  <ng-template #submitModal>
    <div class="modal-header d-flex justify-content-center p-4">
      <h3 class="modal-title text-white">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ 'broadcasting.Upload Confirmation' | translate }}</h3>
      <button type="button" (click)="CloseWindowModal()" class="close" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <h5 style="color:white">{{ 'dataSubs.Are you sure you want to upload the consolidated report. After final submission,the report cannot be edited/changed.Do you want to finally submit the consolidated report' | translate }}</h5>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-success" (click)="submitPopupModal()">{{ 'dataSubs.Confirm' | translate }}</button>
      <button type="button" class="btn btn-danger" (click)="CloseWindowModal()">{{ 'dataSubs.Cancel' | translate }}</button>
    </div>
  </ng-template>
<!-- </div> -->
